import {
    Component,
    inject,
    ChangeDetectionStrategy,
    ElementRef,
    ViewChild,
    effect,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { JustificationModalService } from './justification-modal.service';
import { FocusTrapService } from '../../core/services/focus-trap/focus-trap.service';

const MAX_REASON_LENGTH = 500;

@Component({
    selector: 'app-justification-modal',
    imports: [CommonModule, FormsModule],
    templateUrl: './justification-modal.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JustificationModalComponent {
    readonly modalService = inject(JustificationModalService);
    private readonly focusTrap = inject(FocusTrapService);

    @ViewChild('dialog') dialogRef?: ElementRef<HTMLElement>;

    readonly maxLength = MAX_REASON_LENGTH;
    reason = '';

    private cleanup?: () => void;

    constructor() {
        effect(() => {
            const isOpen = this.modalService.showModal();
            if (isOpen && this.dialogRef?.nativeElement) {
                queueMicrotask(() => {
                    const el = this.dialogRef?.nativeElement;
                    if (!el) return;
                    this.cleanup = this.focusTrap.trap(el, {
                        onEscape: () => this.onCancel(),
                    });
                });
            } else {
                this.cleanup?.();
                this.cleanup = undefined;
            }
        });
    }

    get canSubmit(): boolean {
        return this.reason.trim().length > 0;
    }

    onConfirm(): void {
        if (!this.canSubmit) return;
        this.modalService.confirm(this.reason.trim());
        this.reason = '';
    }

    onCancel(): void {
        this.modalService.cancel();
        this.reason = '';
    }

    onBackdropClick(event: MouseEvent): void {
        if (event.target === event.currentTarget) {
            this.onCancel();
        }
    }
}
